export default "__VITE_ASSET__BTv$OdeT__"